import React from 'react'
import i18next from 'i18next'
import { Link } from '../../utils/link'
import { DecorativeIcon } from '../../utils/spaarneIcons'


export const PreFooterLayout = () => (
  <div className="pre__footer footer__bottom">
    <div className="pre__footer-inner container--m gutter--m">
      <div className="pre__footer-img">
        <img src="/images/pre-footer-hero-image-klopt.svg" alt="Vacancies" />
      </div>
      <div className="pre__footer-content-container">
        <div className="pre__footer-content">
          <p className="pre__footer-intro">{i18next.t(`prefooter:intro`)}</p>
          <Link url={i18next.t(`prefooter:link_url`)} className="button--primary link--external">
            <span className="button__label">{i18next.t(`prefooter:link_label`)}</span>
            <DecorativeIcon iconId="icon--external" className="icon--external-link" width={20} height={20}/>
          </Link>
        </div>
      </div>
    </div>
  </div>
)
